// extracted by mini-css-extract-plugin
module.exports = {"section":"Accordion_section__29OoX","accordion":"Accordion_accordion__zq70M","title":"Accordion_title__2Nuhi","icon":"Accordion_icon__3nLy9","content":"Accordion_content__3PaJ0"};